<template>
  <UserList search-type="3" />
</template>

<script>
import UserList from '@/components/UserList'

export default {
  name: 'ForYouUsers',
  components: {
    UserList,
  }
}
</script>
